import { availableWords } from './map'
import { AvailableWords } from './types'

/**
 * Получение форматера по слову
 *
 * @example
 * ```tsx
 * // Получение форматера должно быть за компонентом, поскольку
 * // форматер не зависит от рендеров
 * const markerPluralFormatter = getPluralFormatter('маркер')
 * const addedPluralFormatter = getPluralFormatter('добавлено')
 *
 * // Внутри компонента
 * const addedAmount = getAddedAmount() // например, 5
 * const markerWord = markerPluralFormatter(addedAmount) // 'маркеров'
 * const addedWord = capitalize(addedPluralFormatter(addedAmount)) // Добавлено
 * const message = `${addedWord} ${addedAmount} ${markerWord}` // 'Добавлено 5 маркеров'
 * ```
 *
 * @param {AvailableWords} word слово, которое требуется согласовать с числительным
 * @returns {(amount: number) => any} функция, возвращающая правильный вариант слова по количеству
 */
export const getPluralFormatter = (word: AvailableWords) => availableWords[word]
